/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';

export const MODAL_DIALOG_EVENTS = {
  OPEN: 'open',
  OPENED: 'opened',
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
  CLOSE: 'close',
}

export default class ModalDialogComponent extends Component {
  get SELECTORS() {
    return {
      dialog: '.modal-dialog',
      closeBtn: '.modal-dialog-close-btn',
    }
  }

  constructor(el) {
    super(el);

    this.dialogList = document.querySelectorAll(this.SELECTORS.dialog);
    this.closeBtnList = document.querySelectorAll(this.SELECTORS.closeBtn);

    this.triggeredBy = undefined
    this.autoCloseOnConfirm = true
  }

  bindEvents() {
    this.bindOnClose();
    this.onClickOutside();
    this.onOpen();
    this.onClose();
  }

  bindOnClose() {
    if (this.closeBtnList) {
      this.closeBtnList.forEach(btn => btn.addEventListener('click', event => {
        event.stopPropagation();
        this.onButtonClick({dialogEvent: MODAL_DIALOG_EVENTS.CLOSE, id: btn.dataset.dialog, event})
      }))
    }
  }

  onButtonClick({dialogEvent, event, id, closeDialog = true}) {
    let that = this;
    if (closeDialog) {
      that.$emit(dialogEvent, {event, triggeredBy: 'ModalDialogComponent', id});
    }
  }

  onOpen() {
    let that = this;
    this.$on(MODAL_DIALOG_EVENTS.OPEN, ({payload}) => {
      let dialog = document.getElementById(`modal-dialog-${payload.id}`)
      if (dialog) {
        dialog.showModal();
      }
      that.triggeredBy = payload.triggeredBy
      that.autoCloseOnConfirm = payload.autoCloseOnConfirm ?? true
    })
  }

  onClose() {
    this.$on(MODAL_DIALOG_EVENTS.CLOSE, ({payload}) => {
      let dialog = document.getElementById(`modal-dialog-${payload.id}`)
      if (dialog.querySelector('select')) {
        const select = dialog.querySelector('select');
        $(select).val(null).trigger('change');
      }
      dialog.close()
    })
  }

  onClickOutside() {
    let that = this;
    this.dialogList.forEach(dialog => {
      dialog.addEventListener('click', (e) => e.stopPropagation());
      dialog.addEventListener('mousedown', function (event) {
        var rect = dialog.getBoundingClientRect();
        var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
        if (!isInDialog) {
          dialog.close();
          that.$emit(MODAL_DIALOG_EVENTS.CLOSE, {event, id: dialog.getAttribute('data-dialog')});
        }
      })
    })
  }

  render() {
    this.warn('Rendering ModalDialogComponent...');
    this.bindEvents();
  }
}
